"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queries = void 0;
const tslib_1 = require("tslib");
/* eslint-disable prettier/prettier */
const graphql_request_1 = require("graphql-request");
const fragments_1 = tslib_1.__importDefault(require("./fragments"));
/*
  Queries
*/
const get = (0, graphql_request_1.gql) `
  query ($id: ID!, $country: CountryCode) @inContext(country: $country) {
    cart(id: $id) {
      ...FullCart
    }
  }
  ${fragments_1.default.fullCartFragment}
`;
exports.queries = {
    get,
};
//# sourceMappingURL=queries.js.map